import { Spinner } from "grommet"
import "./loader.css"

export const LoadingCover=({})=>{
    return <div className="loader">
        <Spinner size="large"/>
    </div>
}